// import AOS from 'aos';
import ProductItem from '../components/product/ProductItem';
import Splide from '@splidejs/splide';
import getTranslation from '../helpers/getTranslation';
import { unitlessBreakpoints } from '../helpers/breakpoints';

const selectors = {
  seriesTabs: '[data-series-tabs]',
  seriesTab: '[data-series]',
  seriesSlider: '[data-series-slider]',
  productGrid: '[data-product-grid]',
  productItemWrapper: '[data-product-item-wrapper]',
  productItem: '[data-product-item]',
  totalProducts: '[data-total-products]',
};

const classes = {
  active: 'pill--active',
  tertiary: 'pill--tertiary',
  hidden: 'hidden',
};

export default class DynamicCollectionGrid {
  constructor(section) {
    this.el = section.el;
    this.section = section;
    this.seriesSlider = null;

    const productItems = section.el.querySelectorAll(selectors.productItem);

    [...productItems].forEach(productItem => {
      new ProductItem(productItem);
    });

    this.init();
  }

  init() {
    const tabsContainer = this.el.querySelector(selectors.seriesTabs);
    if (!tabsContainer) {
      return;
    }

    const tabs = tabsContainer.querySelectorAll(selectors.seriesTab);
    const productItems = this.el.querySelectorAll(selectors.productItemWrapper);

    if (!tabs.length || !productItems.length) {
      return;
    }

    // Initialize the count with all visible products
    const initialCount = productItems.length;
    this.updateTotalProductsCount(initialCount);

    // Initialize series slider (Splide handles resize automatically)
    this.initSeriesSlider();

    // Set up event listeners for tabs
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        this.handleTabClick(tab, tabs, productItems);
      });
    });
  }

  initSeriesSlider() {
    const sliderEl = this.el.querySelector(selectors.seriesSlider);
    if (!sliderEl) {
      return;
    }

    this.seriesSlider = new Splide(sliderEl, {
      type: 'slide',
      autoWidth: true,
      focus: 'left',
      arrows: false,
      pagination: false,
      gap: '0.625rem',
      mediaQuery: 'min',
      breakpoints: {
        [unitlessBreakpoints.md]: {
          destroy: true,
        },
      },
    });

    this.seriesSlider.mount();
  }

  handleTabClick(clickedTab, allTabs, productItems) {
    const selectedSeries = clickedTab.getAttribute('data-series');

    // Update tab active states
    allTabs.forEach(tab => {
      const isActive = tab === clickedTab;
      tab.setAttribute('aria-pressed', isActive.toString());
      if (isActive) {
        tab.classList.add(classes.active);
        tab.classList.remove(classes.tertiary);
      } else {
        tab.classList.remove(classes.active);
        tab.classList.add(classes.tertiary);
      }
    });

    // Filter products
    let visibleCount = 0;
    productItems.forEach(itemWrapper => {
      const productItem = itemWrapper.querySelector(selectors.productItem);
      if (!productItem) {
        return;
      }

      const productSeries = productItem.getAttribute('data-product-series');

      if (selectedSeries === 'all') {
        // Show all products
        itemWrapper.classList.remove(classes.hidden);
        visibleCount++;
      } else {
        // Show only products matching the selected series
        // Compare as strings to handle number matching
        // Avoid using "if" as only statement in an else block for lint compliance
        const shouldShow =
          productSeries &&
          productSeries.toString() === selectedSeries.toString();

        if (shouldShow) {
          itemWrapper.classList.remove(classes.hidden);
          visibleCount++;
        } else {
          itemWrapper.classList.add(classes.hidden);
        }
      }
    });

    // Update total products count
    this.updateTotalProductsCount(visibleCount);

    // AOS.refresh();
  }

  updateTotalProductsCount(count) {
    const totalProductsEl = this.el.querySelector(selectors.totalProducts);
    if (!totalProductsEl) {
      return;
    }

    // Use the translation helper to format the count properly
    const translatedText = getTranslation('collections.total_products', {
      count: count.toString(),
    });

    totalProductsEl.textContent = translatedText;
  }

  onSectionUnload() {
    // Clean up slider
    if (this.seriesSlider) {
      this.seriesSlider.destroy();
      this.seriesSlider = null;
    }
  }
}
